<script setup>
/**
 * Site-wide legal footer for Price Forecast Hub — same structure as Outpost
 * TimeseriesChart.vue `.legal-footer` (legal links only).
 */
</script>

<template>
  <footer class="legal-footer" data-testid="app-legal-footer">
    <div class="legal-links">
      <router-link to="/financial-disclaimer" class="legal-footer-link">Financial Disclaimer</router-link>
      <router-link to="/copyright" class="legal-footer-link">Copyright</router-link>
      <router-link to="/privacy" class="legal-footer-link">Privacy Policy</router-link>
      <router-link to="/terms-of-service" class="legal-footer-link">Terms of Service</router-link>
      <router-link to="/cookies" class="legal-footer-link">Cookie Policy</router-link>
    </div>
  </footer>
</template>

<style scoped>
.legal-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: beige;
  padding: 0.5rem;
  font-size: 0.8rem;
  border-top: 1px solid #dee2e6;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  box-sizing: border-box;
  min-height: 40px;
  justify-content: center;
}

.legal-links {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.legal-footer a,
.legal-footer .legal-footer-link {
  color: #666;
  text-decoration: none;
  transition: color 0.2s;
}

.legal-footer a:hover,
.legal-footer .legal-footer-link:hover,
.legal-footer .legal-footer-link.router-link-active {
  color: #36a2eb;
}

@media (max-width: 480px) {
  .legal-footer {
    padding: 0.1rem;
    font-size: 0.55rem;
    min-height: 32px;
  }

  .legal-links {
    gap: 0.5rem;
  }
}

/* A phone held sideways has too little vertical room to spend on a fixed footer. */
@media (orientation: landscape) and (max-height: 500px) {
  .legal-footer {
    display: none;
  }
}
</style>
